// Global parameters and configuration
//
// Per-branch deployment model: each branch (main / stag / prod) hardcodes its
// own defaults below. CI/CD doesn't need to inject env vars — the branch IS
// the config. Env-var overrides (REACT_APP_*) are an additive escape hatch
// for local dev: a developer can put values in .env.development.local
// (gitignored by CRA) to point this app at a different BE / redirect target
// without editing source on their branch.
//
// In deployed builds, leave the env vars unset and the hardcoded defaults
// take effect.
export const PARAMS = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    'https://apis.veytan.com/prod/api',
  DEFAULT_REDIRECT_URL:
    process.env.REACT_APP_DEFAULT_REDIRECT_URL ||
    'https://hcm.veytan.com/home/dashboard',
  TOKEN_STORAGE_KEY: 'veytan_auth_accesstoken',
  TOKEN_STORAGE_KEY_REFRESH: 'veytan_auth_refreshtoken',
  TOKEN_STORAGE_KEY_ID: 'veytan_auth_idtoken',
  USER_STORAGE_KEY: 'veytan_userinfo'
};
